import { useRef, useState } from "react"
import { useCurrentTripContext } from '../hooks/useCurrentTripContext'
import { useAuthContext } from '../hooks/useAuthContext'

const TripLuggageNotes = ({trip}) => {
    const { dispatch } = useCurrentTripContext()
    const { user } = useAuthContext()
    const [tripLuggageNotes, setTripLuggageNotes] = useState(trip.luggage_notes) 
    const [error, setError] = useState(null)
    const [status, setStatus] = useState(null)
    const [disableCheck, setDisableCheck] = useState(false)
    const timeoutRef = useRef(null)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (disableCheck) return
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = null
        }
        setStatus('loading')
        setDisableCheck(true)
        if (!user) {
            setStatus(null)
            setDisableCheck(false)
            setError('Not Authenticated')
            return
        }
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trip/luggage/` , {
            method: 'PATCH',
            body: JSON.stringify({_id: trip._id, luggage_notes: tripLuggageNotes}),
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
        const json = await response.json() //response.json in a delete request is the document that was just deleted
        
        if (!response.ok) {
            setStatus(null)
            setDisableCheck(false)
            setError(json.error)
        }

        if (response.ok) {
            setError(null)
            console.log('Luggage Notes Updated')
            dispatch({type: 'SET_TRIP', payload: json})
            setStatus('success')
            setDisableCheck(false)
            timeoutRef.current = setTimeout(() => {
                setStatus(null)
                timeoutRef.current = null
            }, 3000)
        }
    
    }   

    return (
        <form className="trip-notes" onSubmit={handleSubmit}>
            <label>Luggage Notes:</label>
            <textarea 
                onChange={(e) => setTripLuggageNotes(e.target.value)}
                value={tripLuggageNotes}
                className="notes-input">
            </textarea>
            <button disabled={disableCheck}>Save</button>
            {status === 'loading' && <span className="loading">Saving...</span> /*change colour of these spans*/} 
            {status === 'success' && <span className="save-success">Save Successful</span>}
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default TripLuggageNotes